import BaseSubscriptionStore from '../../shared-solo/stores/BaseSubscriptionStore/BaseSubscriptionStore'
import analytics from './analytics'

export default class SubscriptionStore extends BaseSubscriptionStore {
  manageSubscription = async () => {
    const { communication, uiStore } = this.rootStore
    analytics.track('Manage Solo Subscription Link')

    const { manageSoloSubscriptionUrl } = await communication.requester.manageSoloSubscriptionUrl()
    if (manageSoloSubscriptionUrl) {
      uiStore.openLink(manageSoloSubscriptionUrl, '_self')
    } else {
      this.showLinkError()
    }
  }

  openChargebeeSubscriptionCheckout = async (item_price_id: string) => {
    const { uiStore } = this.rootStore
    const { soloSubscriptionUrl } = await this.rootStore.communication.requester.soloSubscriptionUrl({ data: { item_price_id } })

    if (soloSubscriptionUrl) {
      uiStore.openLink(soloSubscriptionUrl, '_self')
    } else {
      this.showLinkError()
    }
  }
}

